import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import { env as config } from "./config";

const firebaseApp = initializeApp(config);
const functions = getFunctions(firebaseApp);
const db = getFirestore(firebaseApp);

export { functions, httpsCallable, db };
